export const getEnvironment = () => process.env.NODE_ENV;
